<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/contacts">Контакты</div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Контакты
    </h1>
    <p>Адрес: 105064, г. Москва, ул. Старая Басманная, д.7, стр.2&nbsp;<br />
      Телефон: +7 (495) 135-43-15<br />
      E-mail:&nbsp;<a href="mailto:fsetan@gmail.com" style="font-family: Tahoma; line-height: normal;">fsetan@gmail.com</a></p>

    <p><strong>На машине:</strong><br />
      Двигайтесь по внешней стороне Садового кольца по ул. Садовой-Черногрязская до дома №13/3, въезд через арку.</p>

    <p><strong>Пешком:</strong><br />
      <em>от станции метро Курская.</em></p>

    <p>Выход №1 из метро Курская (кольцевая) на ул. Земляной Вал. Поворот направо по внешней стороне Садового кольца около 700 м. После магазина Азбуки вкуса поворот в арку. Вам нужно здание с белыми колоннами и белой лестницей.</p>

    <p><em>от станции метро Красные ворота.</em></p>

    <p>Выход №1 из метро Красные Ворота на ул. Садовая-Черногрязская. Нужно перейти садовое кольцо и двигаться прямо по ул.Садовая-Черногрязская до дома №13. Перед магазином Азбука вкуса поворот в арку. Вам нужно здание с белыми колоннами и белой лестницей.</p>


    <p style="text-align: center;"><img src="/assets/office.jpg" style="width: 600px" alt="" title="" /></p>
  </div>
</div>
<app-footer></app-footer>
